import { snakeCase, varchar, boolean, text } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { clientsTable } from './clients.table'

export const signupAccessControlTable = snakeCase.table(
    'signup_access_control',
    {
        id: id('sac'),
        clientId: text()
            .notNull()
            .references(() => clientsTable.id, {
                onDelete: 'cascade',
                onUpdate: 'cascade',
            }),
        userEmail: varchar({ length: 150 }).notNull().unique(),
        isBlocked: boolean().default(false),
        ...timestamps,
    },
)
